import React from 'react';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './utils/RouteProvider';
import { theme } from './utils/ThemeProvider';

const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={(muiTheme) => ({
          ':root': {
            colorScheme: 'light',
          },
          'html, body, #root': {
            minHeight: '100%',
            backgroundColor: muiTheme.palette.background.default,
          },
          body: {
            fontFamily: muiTheme.typography.fontFamily,
            color: muiTheme.palette.text.primary,
          },
          a: {
            textDecoration: 'none',
            color: 'inherit',
          },
          'img, picture, video, canvas, svg': {
            display: 'block',
            maxWidth: '100%',
          },
        })}
      />
      <Toaster
        position='top-right'
        toastOptions={{
          duration: 4000,
          style: {
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontWeight: 600,
            borderRadius: 12,
          },
        }}
      />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
